import { BreadcrumbItem, type BreadcrumbItemProps } from "@heroui/react";

BreadcrumbItem.displayName = "RecareUI.BreadcrumbItem";

export { BreadcrumbItem, type BreadcrumbItemProps };
